var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0" },
    [
      _c(
        "v-row",
        {
          staticClass: "mb-5 v-sidebar__gallery",
          class: { "only-one": _vm.galleryImages.length === 1 },
        },
        [
          _vm.$lds.isEmpty(_vm.galleryImages)
            ? _c(
                "v-col",
                {},
                [
                  _c("v-skeleton-loader", {
                    staticStyle: { "margin-bottom": "4px" },
                    attrs: { type: "image", width: "100%", height: "360" },
                  }),
                  _vm._v(" "),
                  _vm.galleryImages.length >= 2
                    ? _c("v-skeleton-loader", {
                        attrs: { type: "image", width: "100%", height: "87" },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "v-col",
                [
                  _c(
                    "div",
                    { staticClass: "position-relative" },
                    [
                      _c("div", { staticClass: "gallery-badges" }, [
                        _vm.productDetails.is_hot
                          ? _c(
                              "span",
                              {
                                staticClass: "gallery-badge gallery-badge--hot",
                              },
                              [_vm._v("HOT")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.productDetails.is_new
                          ? _c(
                              "span",
                              {
                                staticClass: "gallery-badge gallery-badge--new",
                              },
                              [_vm._v("NEW")]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "VueSlickCarousel",
                        _vm._b(
                          {
                            ref: "gCarousel1",
                            staticClass:
                              "overflow-hidden v-sidebar__gallery-heros",
                            attrs: { asNavFor: _vm.gSlider2 },
                            on: { afterChange: _vm.stopAutoplayAtFirstImage },
                          },
                          "VueSlickCarousel",
                          _vm.gHerosOption,
                          false
                        ),
                        _vm._l(_vm.galleryImages, function (photo, i) {
                          return _c(
                            "div",
                            {
                              key: `C-${i}`,
                              staticClass: "c-pointer v-sidebar__gallery-image",
                            },
                            [
                              _c("img", {
                                staticClass: "img-fluid",
                                attrs: {
                                  src: photo,
                                  draggable: "false",
                                  width: "100%",
                                  alt: "preview",
                                },
                              }),
                            ]
                          )
                        }),
                        0
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.galleryImages.length > 1 || _vm.has360
                    ? _c(
                        "VueSlickCarousel",
                        _vm._b(
                          {
                            ref: "gCarousel2",
                            staticClass:
                              "overflow-hidden v-sidebar__gallery-thumbs",
                            attrs: { asNavFor: _vm.gSlider1 },
                          },
                          "VueSlickCarousel",
                          _vm.gThumbsOption,
                          false
                        ),
                        [
                          _vm._l(_vm.galleryImages, function (photo, i) {
                            return _c(
                              "div",
                              {
                                key: `C-${i}`,
                                staticClass:
                                  "c-pointer v-sidebar__gallery-image",
                                on: {
                                  click: function ($event) {
                                    return _vm.goToImage(i)
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "img-fluid",
                                  attrs: {
                                    src: photo,
                                    draggable: "false",
                                    width: "100%",
                                    alt: "preview thumbnail",
                                  },
                                }),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _vm.has360
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "c-pointer v-sidebar__gallery-image v-gallery__360-thumb",
                                  on: { click: _vm.open360Viewer },
                                },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid",
                                    attrs: {
                                      src: _vm.photos360[0],
                                      draggable: "false",
                                      width: "100%",
                                      alt: "360° 뷰어",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "v-gallery__360-badge" },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            viewBox: "0 0 36 36",
                                            width: "22",
                                            height: "22",
                                            fill: "currentColor",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M18 4C10.3 4 4 10.3 4 18s6.3 14 14 14 14-6.3 14-14S25.7 4 18 4zm0 25.5c-6.3 0-11.5-5.2-11.5-11.5S11.7 6.5 18 6.5 29.5 11.7 29.5 18 24.3 29.5 18 29.5z",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: { d: "M24 11l-10 5 10 5z" },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("360°")]),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasPdf
        ? _c("div", { staticClass: "mt-2 mb-5" }, [
            _c(
              "button",
              {
                staticClass: "preview-btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.openPreview.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "16",
                      height: "16",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z",
                      },
                    }),
                    _c("circle", { attrs: { cx: "12", cy: "12", r: "3" } }),
                  ]
                ),
                _vm._v("\n            제품 미리보기\n        "),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "760", "content-class": "v-dialog--360" },
          model: {
            value: _vm.show360Viewer,
            callback: function ($$v) {
              _vm.show360Viewer = $$v
            },
            expression: "show360Viewer",
          },
        },
        [
          _vm.show360Viewer
            ? _c("Product360Viewer", {
                attrs: { frames: _vm.photos360 },
                on: {
                  close: function ($event) {
                    _vm.show360Viewer = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            "max-width": _vm.previewSize.w,
            "content-class": "preview-layer-dialog",
          },
          model: {
            value: _vm.showPreview,
            callback: function ($$v) {
              _vm.showPreview = $$v
            },
            expression: "showPreview",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "preview-layer-box",
              style: {
                width: _vm.previewSize.w + "px",
                height: _vm.previewSize.h + "px",
              },
            },
            [
              _vm.showPreview
                ? _c("iframe", {
                    staticClass: "preview-layer-iframe",
                    attrs: { src: _vm.previewUrl },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isResizing
                ? _c("div", { staticClass: "preview-resize-cover" })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "preview-resize-handle",
                  on: {
                    mousedown: function ($event) {
                      $event.preventDefault()
                      return _vm.startResize.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "rgba(255,255,255,0.5)",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M10 2L2 10M10 6L6 10M10 10L10 10",
                          stroke: "rgba(255,255,255,0.5)",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }